<div class="date-picker-overlay dropdown-shadow white-bg radius-m p-1">
    <ng-container *ngFor = "let date of dateArr">
        <p class=" px-1 py-2 content-m primary-text radius-round" [ngClass]="date | highlight : dates.value"  (click)="date_click(date)">{{date}}</p>
    </ng-container>
</div>